export const CODI_DEMO_YOUTUBE_URL = 'https://www.youtube.com/watch?v=QygeDOSI8dc' as const;

/** Split hero h2 + inline accent: same fluid type so both scale together on small viewports */
export const HOME_V10_SPLIT_HEADLINE_TYPO = {
  fontWeight: 800,
  fontSize: 'clamp(42px, 5.5vw, 72px)',
  lineHeight: 1.02,
  letterSpacing: '-0.035em'
} as const;

export const WHY_CODI_PHRASES = [
  'works 24/7.',
  'knows your offices better than anyone.',
  'has managed 220+ offices.',
  'has worked with 43 local vendors.',
  'will never quit.',
  'saves you $60,000 per year.'
] as const;

export const TESTIMONIALS = [
  {
    quote: 'Codi has transformed how we manage office operations.',
    by: 'Katrina · Chief of Staff',
    initial: 'K'
  },
  {
    quote: 'The most cost-effective and modern way to run an office.',
    by: 'Marcus · VP Operations',
    initial: 'M'
  },
  {
    quote: 'I run our NYC office from London.',
    by: 'Sofia · Head of Workplace',
    initial: 'S'
  },
  {
    quote: 'My office manager finally got into HR.',
    by: 'Riya · Ops Lead',
    initial: 'R'
  },
  {
    quote: 'We could not have asked for a better partner to grow with.',
    by: 'Zain · CEO & founder',
    initial: 'Z'
  },
  {
    quote: "We're very happy in our office and we credit Codi for that.",
    by: 'Priya · People Ops',
    initial: 'P'
  },
  {
    quote: "I don't know how we would do it without Codi.",
    by: 'Alex · CFO',
    initial: 'A'
  }
] as const;

export const MARQUEE_LOGOS: ReadonlyArray<{ label: string; variant: 'default' | 'italic' | 'mono' | 'thin' }> = [
  { label: 'Mirendil', variant: 'thin' },
  { label: 'vibe', variant: 'italic' },
  { label: 'FurtherAI', variant: 'default' },
  { label: 'FINCH', variant: 'mono' },
  { label: 'Quantexa', variant: 'thin' },
  { label: 'Workwhile', variant: 'default' },
  { label: 'Posthog', variant: 'italic' },
  { label: 'Baton', variant: 'default' },
  { label: 'Northbeam', variant: 'italic' }
];

export const INTEL_STEPS = [
  'kitchen sink leak reported',
  'analyzing lease responsibility for plumbing repairs',
  "found that it's tenant's responsibility",
  'checking building insurance requirements',
  'found plumber that meets building requirements',
  'checked after-hours building rules',
  'plumber scheduled for Tuesday'
] as const;
